var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.32284 14.673L14.673 9.32284M10.6604 7.66012L13.1733 5.15225C13.9278 4.40987 14.9452 3.99572 16.0037 4.00003C17.0623 4.00434 18.0762 4.42676 18.8247 5.17526C19.5732 5.92377 19.9957 6.93772 20 7.99626C20.0043 9.0548 19.5901 10.0722 18.8477 10.8267L16.3349 13.3354M7.66012 10.6604L5.15225 13.1733C4.40987 13.9278 3.99572 14.9452 4.00003 16.0037C4.00434 17.0623 4.42676 18.0762 5.17526 18.8247C5.92377 19.5732 6.93772 19.9957 7.99626 20C9.0548 20.0043 10.0722 19.5901 10.8267 18.8477L13.3354 16.3349",
    stroke: "#5547EB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkSimple);
export default __webpack_public_path__ + "static/media/LinkSimple.d1d9d01c7e583c40902da96b183e327b.svg";
export { ForwardRef as ReactComponent };